import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Popup, Text } from 'shared/components'
import { ServicesContext } from 'services/context'
import { useContext } from 'react'
import { toaster } from 'utils/toast-wrapper'
import * as styles from './styles'

const ReceiptCellComponent = ({ value: { stateDescription, hasAddress, id } }) => {
	const services = useContext(ServicesContext)
	const { memberService } = services
	const isPlayed = stateDescription === 'WIN'
	const [downloadLoading, setDownloadLoading] = useState(false)
	const [emailLoading, setEmailLoading] = useState(false)

	const handleDownload = async () => {
		try {
			setDownloadLoading(true)
			await memberService.downloadReceipt(id)
			toaster.success('Download successful')
		} catch (error) {
			console.error('Failed to download receipt:', error)
			toaster.error('Download failed')
		} finally {
			setDownloadLoading(false)
		}
	}

	const handleEmailRequest = async () => {
		try {
			setEmailLoading(true)
			await memberService.requestReceiptByEmail(id)
			toaster.success('Email request successful')
		} catch (error) {
			console.error('Failed to request receipt by email:', error)
			toaster.error('Email request failed')
		} finally {
			setEmailLoading(false)
		}
	}

	if (!isPlayed) {
		return null
	}

	const smallerButtonStyle = {
		padding: '0.15rem 0.3rem',
		minHeight: 'auto',
		fontSize: '0.6rem',
		lineHeight: '1',
		transform: 'scale(0.85)'
	}

	const buttons = (
		<div css={styles.buttonGroup}>
			<Button
				small
				primary
				loading={downloadLoading}
				disabled={!hasAddress || downloadLoading}
				onClick={handleDownload}
				css={smallerButtonStyle}
			>
				Download PDF
			</Button>
			<Button
				small
				variant="success"
				loading={emailLoading}
				disabled={!hasAddress || emailLoading}
				onClick={handleEmailRequest}
				css={smallerButtonStyle}
			>
				Request Email
			</Button>
		</div>
	)

	return (
		<div css={styles.wrapper}>
			{!hasAddress ? (
				<Popup useAsTooltip trigger={buttons}>
					<div css={styles.tooltip}>
						<Text white size={11}>Add Address in your Personal information to download or request by email your donation receipts.</Text>
					</div>
				</Popup>
			) : (
				buttons
			)}
		</div>
	)
}

ReceiptCellComponent.propTypes = {
	value: PropTypes.shape({
		stateDescription: PropTypes.string.isRequired,
		hasAddress: PropTypes.bool.isRequired,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	}).isRequired,
}

export default ReceiptCellComponent 